import React, { useEffect, useState } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiRegion from "../../../core/api/api.region";
import ApiHome from "../../../core/api/api.home";
import { TextField } from "@mui/material";
import SwalMessage from "../_Components/SwalMessage";
import SelectComponent from "../_Components/ReactSelectComponent";


export const CreateOrEditRegion = ({ showModalEditRegion, setShowModalEditRegion, selectedRegion }) => {
  const [title, setTitle] = useState("ایجاد شهر یا استان جدید");
  const [regionTypes, setRegionTypes] = useState()
  const [provinces, setProvinces] = useState([])
  const handleClose = () => {
    setShowModalEditRegion(false);
  };
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    setValue,
    watch
  } = useForm({ defaultValues: { id: null, regionType: { label: "شهر", value: 1 } } });
  useEffect(() => {
    (async () => {
      try {
        const regionTypes = (await ApiHome.getEnums({ enumName: "RegionType" })).data
        setRegionTypes(regionTypes.map(rt => ({ label: rt.title, value: +rt.value })))
        const regions = (await ApiRegion.getAllRegionsByType({ type: 2 }))
        setProvinces(regions.map(pr => ({ label: pr.name, value: pr.id })))

        if (selectedRegion != null) {
          const response = await ApiRegion.get(selectedRegion);
          // if (response.succeeded == true) {
          // مقدار اولیه
          setValue("id", response.id);
          setValue("name", response.name);
          setValue("englishName", response.englishName);
          setValue("pageTitle", response.pageTitle);
          setValue("metaDescription", response.metaDescription);
          setValue("viewOrder", response.viewOrder);
          setValue("regionType", regionTypes.map(rt => ({ label: rt.title, value: +rt.value })).find(r => r.value == response.regionType))
          setValue("provinceId", regions.map(rt => ({ label: rt.name, value: +rt.id })).find(r => r.value == response.provinceId))
          setTitle(response.regionType == 1 ? "ویرایش شهر" : "ویرایش استان");

          //}
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, []);
  const onSubmit = async (data) => {
    data.regionType = data.regionType.value
    if (data.provinceId) {
      if (data.regionType == 1) data.provinceId = data.provinceId?.value
      else delete data.provinceId
    }
    try {
      let response = null;
      if (data.id == null) response = await ApiRegion.create(data);
      else response = await ApiRegion.update(data);
      document.getElementById("submitButton").click();
      handleClose()
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <Modal centered size="md" show={showModalEditRegion} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col xs="12">
              <Row>
                <Col xs="12">
                  <Controller
                    name="name"
                    control={control}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                  {errors.title && <span>لطفا نام شهر را وارد نمایید</span>}
                </Col>
                <Col xs="12">
                  <Controller
                    name="englishName"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="نام انگلیسی"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="regionType"
                    control={control}
                    render={({ field }) => (
                      <SelectComponent
                        options={regionTypes}
                        placeholder="نوع"
                        className="mt-5"
                        noClear
                        field={field}
                      />
                    )}
                  />
                  {errors.agentId && <div class="mt-2 pl-4 text-danger">**لطفا نماینده را وارد نمایید</div>}
                </Col>
                {watch("regionType")?.value == 1 && <Col xs="12">
                  <Controller
                    name="provinceId"
                    control={control}
                    render={({ field }) => (
                      <SelectComponent
                        options={provinces}
                        placeholder="استان"
                        className="mt-5"
                        noClear
                        field={field}
                      />
                    )}
                  />
                  {errors.agentId && <div class="mt-2 pl-4 text-danger">**لطفا نماینده را وارد نمایید</div>}
                </Col>}
                <Col xs="12">
                  <Controller
                    name="pageTitle"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="عنوان صفحه"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="metaDescription"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="metaDescription"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
                <Col xs="12">
                  <Controller
                    name="viewOrder"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        type="number"
                        label="ترتیب نمایش"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        onInput={onChange}
                      />
                    )}
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
